import { WithStyles, withStyles } from '@material-ui/styles'
import { observer } from 'mobx-react'
import React from 'react'
import { RotationCheckStyles } from './rotationCheck.style'

import bind from 'bind-decorator'
import { action, IReactionDisposer, observable, reaction } from 'mobx'
import { windowStore } from 'stores/windowStore'

import RotatePleaseImage from './assets/rotatePlease.svg'
import { currentStory } from 'stores/currentStoryStore'
import { sliderStore } from 'stores/sliderStore'
import classnames from 'classnames'

interface RotationCheckProps extends WithStyles<typeof RotationCheckStyles> {
  position?: number
}
@observer
class RotationCheckCls extends React.Component<RotationCheckProps> {
  @observable pleaseRotate: boolean = !windowStore.windowIsLandscape

  disposers: IReactionDisposer[] = []
  componentDidMount() {
    // https://stackoverflow.com/questions/65463449/window-innerwidth-incorrect-in-chrome-ios-87-0-4280-77-after-orientation-change
    window.addEventListener('orientationchange', () => {
      setTimeout(() => {
        this.setPleaseRotate(window.innerHeight < window.innerWidth)
      }, 1000) // Needs to be 1s because of screen rotation animation on iPad
    })

    this.disposers.push(
      reaction(
        () => windowStore.orientationJustChanged,
        () => {
          this.setPleaseRotate(windowStore.windowIsLandscape)
        }
      )
    )

    this.disposers.push(
      reaction(
        () => currentStory.sideBarIsShown,
        () => {
          if (this.pleaseRotate) {
            sliderStore.setShowContent(false)
            currentStory.setSidebarShown(false)
            sliderStore.setChaptersBarVisibility(false)
            currentStory.setBlocking(true)
          }
        }
      )
    )
  }

  @bind
  @action
  setPleaseRotate(isLandscape: boolean) {
    this.pleaseRotate = !isLandscape
    sliderStore.setChaptersBarVisibility(isLandscape)
    sliderStore.setShowContent(isLandscape)
    currentStory.setSidebarShown(isLandscape)
    currentStory.setBlocking(!isLandscape)
  }

  render() {
    const { classes } = this.props

    const pleaseRotateElement: JSX.Element = (
      <div
        className={classnames(classes['container'], classes['backdrop-blur'])}
        style={this.pleaseRotate ? {} : { display: 'none' }}
      >
        <div className={classnames(classes['locked-screen-container'])}>
          <div className={classes['inner-container']}>
            <div className={classes['bold-text']}>
              Die Inhalte dieser Seite sind für den Landscape Modus optimiert.
            </div>
            <div>Bitte drehe das Tablet um 90° – vielen Dank!</div>
            <div className={classes.divider} />
            <img src={RotatePleaseImage} alt="rotate device" />
          </div>
        </div>
      </div>
    )

    return pleaseRotateElement
  }
}
export default withStyles(RotationCheckStyles, { name: 'RotationCheck' })(
  RotationCheckCls
)
